import { render, staticRenderFns } from "./DistributionListSelectRuleInput.vue?vue&type=template&id=5cc4a402"
import script from "./DistributionListSelectRuleInput.vue?vue&type=script&lang=js"
export * from "./DistributionListSelectRuleInput.vue?vue&type=script&lang=js"
import style0 from "./DistributionListSelectRuleInput.vue?vue&type=style&index=0&id=5cc4a402&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports